import React, { Component, ReactNode } from "react";
import { Button, Grid, Header, Popup } from 'semantic-ui-react';
import { MessageSourceProps, withMessages } from 'react-message-source';
import PxGrid from 'components/layout/PxGrid';
import FormButtonsRow from 'components/layout/FormButtonsRow';

interface Props extends MessageSourceProps {
  message?: string,
  onOpen?: () => void,
  poperDependencies?: any[],
  onConfirmAction: () => void,
  renderTarget: React.ReactNode,
  position?:
      | 'top left'
      | 'top right'
      | 'bottom right'
      | 'bottom left'
      | 'right center'
      | 'left center'
      | 'top center'
      | 'bottom center',
  disabled?: boolean,
  renderContent?: (toggle?: () => void) => ReactNode,
  primaryButtonText?: string,
  secondaryButtonText?: string,
  style?: Object
}

interface State {
  popupOpen: boolean
}

class ConfirmActionPopup extends Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {
      popupOpen: false
    }
  }

  togglePopup = () => {
    this.setState(({popupOpen}: State) => ({
      popupOpen: !popupOpen
    }));
  };

  onConfirm = () => {
    this.togglePopup();
    this.props.onConfirmAction();
  };

  render(): React.ReactNode {

    const {
      renderTarget,
      position,
      disabled,
      poperDependencies,
      onOpen,
      renderContent = this.renderContent,
      style
    } = this.props;

    const {popupOpen} = this.state;

    return (
        <Popup
            trigger={(<span className="trigger-wrapper">{renderTarget}</span>)}
            content={renderContent(this.togglePopup)}
            open={popupOpen}
            onClose={() => !disabled && this.togglePopup()}
            onOpen={() => {
              if (!disabled) {
                this.togglePopup();

                if (onOpen) {
                  onOpen();
                }
              }
            }}
            on='click'
            position={position || 'top center'}
            hideOnScroll
            style={style}
        />
    );
  };

  renderContent = (toggle: () => void): React.ReactNode => {

    const {
      primaryButtonText = this.props.getMessage("button.yes"),
      secondaryButtonText = this.props.getMessage("button.no"),
      message
    } = this.props;

    return (
        <PxGrid>
          <Grid.Row>
            <Grid.Column>
              <Header size="small">{message}</Header>
            </Grid.Column>
          </Grid.Row>
          <FormButtonsRow>
            <Button compact primary onClick={this.onConfirm}>{primaryButtonText}</Button>
            <Button compact onClick={this.togglePopup}>{secondaryButtonText}</Button>
          </FormButtonsRow>
        </PxGrid>
    );
  }
}

export default withMessages(ConfirmActionPopup);
